import { getFilterRole } from '../../../Infrastructure/Store/role/role.actions';
import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Groups, StatusUSerGroups } from 'projects/access-control/src/app/Domain/Entities/group.interface';
import { IPkSk, IRole } from 'projects/access-control/src/app/Domain/Entities/roles/role.interface';
import {
	createStatusGroup,
	updateStatusGroup,
} from 'projects/access-control/src/app/Infrastructure/Store/groups/groups.action';
import { cleanRoles, getRole } from 'projects/access-control/src/app/Infrastructure/Store/role/role.actions';
import { selectRoleState } from 'projects/access-control/src/app/Infrastructure/Store/role/role.selectors';
import { TranslateService } from '@mangosoft/mango-layout';
import { select, Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { IconsStatus, IIconsStatus } from './status';
import { DataPagination } from 'projects/access-control/src/app/Domain/Adapters';
import { RoleService } from 'projects/access-control/src/app/Infrastructure/Store/role/roles.service';

interface DataModal {
	type: string;
	group: Groups;
	status: StatusUSerGroups;
}

interface translateModalStatus {
	name: string;
	description: string;
	roles: string;
	search: string;
	buttonSave: string;
	buttonCancel: string;
}
@Component({
	selector: 'app-modal-status-groups',
	templateUrl: './modal-status-groups.component.html',
	styleUrls: ['./modal-status-groups.component.scss'],
})
export class ModalStatusGroupsComponent implements OnInit, OnDestroy {
	formStatus!: FormGroup;
	subscriptionRole!: Subscription;
	roles: IRole[] = [];
	search = '';
	pagination: DataPagination = {} as DataPagination;
	icon: IIconsStatus = IconsStatus[0];
	rolesSelected: IRole[] = [];
	isSelectIcon = false;
	translateModal: translateModalStatus = {} as translateModalStatus;
	subscriptionTranslate!: Subscription;
	selector = '.roles';
	loading = true;
	activeUpdate = true;
	loadingRoles = false;
	constructor(
		public dialogRef: MatDialogRef<ModalStatusGroupsComponent>,
		@Inject(MAT_DIALOG_DATA) public data: DataModal,
		public dialog: MatDialog,
		private formBuilder: FormBuilder,
		private store: Store,
		private translate: TranslateService,
		private searchRoles: RoleService
	) {}

	ngOnInit(): void {
		this.initModalStatus();
	}

	initModalStatus() {
		this.dataTranslate();
		this.formStatus = this.formBuilder.group({
			name: [this.data.status.name, [Validators.required]],
			color: [this.data.status.color || '#E0FAD9', [Validators.required]],
			description: [this.data.status.description, []],
		});
		if (this.data.type === 'updateStatus') {
			this.updateRoles();
			this.formStatus.controls.name.disable();
			this.icon.url = this.data.status.image;
		}
		this.store.dispatch(cleanRoles());
		setTimeout(() => {
			this.getRoles();
			this.store.dispatch(
				getFilterRole({ url: `?_size=10&_pkClient=${this.data.group.clientPk}` })
			);
		}, 1000);
	}

	iconSelected(icon: IIconsStatus) {
		this.icon = icon;
		this.isSelectIcon = false;
	}
	onNoClick(): void {
		this.dialogRef.close();
	}

	getRoles() {
		this.subscriptionRole = this.store
			.pipe(select(selectRoleState))
			.subscribe(({ roles, pagination, loading }) => {
				this.pagination = pagination;
				this.loading = loading;
				if (!loading) {
					roles.forEach((element) => {
						const role = this.roles.find(
							(elementRole) => elementRole.sk === element.sk && elementRole.pk === element.pk
						);
						const roleSelected = this.rolesSelected.find(
							(elementRole) => elementRole.sk === element.sk && elementRole.pk === element.pk
						);
						if (!role?.sk && !roleSelected?.sk) {
							this.roles = [...this.roles, element];
						}
					});
					if (this.roles.length < 5 && this.pagination.next) {
						this.store.dispatch(
							getFilterRole({
								url: `?_size=10&_name=${this.search}&_page=${this.pagination.next}&_pkClient=${this.data.group.clientPk}`,
							})
						);
					}
				}
			});
	}

	onScroll() {
		if (this.pagination.next) {
			if (this.search.length > 0) {
				this.store.dispatch(
					getFilterRole({
						url: `?_size=10&_page=${this.pagination.next}&_pkClient=${this.data.group.clientPk}`,
					})
				);
			} else {
				this.store.dispatch(
					getFilterRole({
						url: `?_size=10&_name=${this.search}&_page=${this.pagination.next}&_pkClient=${this.data.group.clientPk}`,
					})
				);
			}
		}
	}

	updateRoles() {
		const roles: IPkSk[] = this.data.status.roles;
		this.loadingRoles = roles.length > 0 ? true : false;
		roles.forEach((rolesId, index) => {
			this.searchRoles
				.getFilterRoles(`?_pkClient=${this.data.group.clientPk}&_rolId=${rolesId.sk}`)
				.subscribe(
					({ data }) => {
						if (data.length > 0) {
							this.rolesSelected.push(data[0]);
							this.rolesSelected = [...this.rolesSelected];
						}
						if (roles.length - 1 === index) {
							this.loadingRoles = false;
						}
					},
					(error) => {
						this.loadingRoles = false;
					}
				);
		});
	}
	searchRole() {
		if (this.search.length === 0) {
			this.store.dispatch(
				getFilterRole({ url: `?_size=10&_pkClient=${this.data.group.clientPk}` })
			);
		} else {
			this.store.dispatch(cleanRoles());
			this.roles = [];
			this.store.dispatch(
				getFilterRole({
					url: `?_size=10&_name=${this.search}&_pkClient=${this.data.group.clientPk}`,
				})
			);
		}
	}

	addRole(role: IRole) {
		this.rolesSelected.push(role);
		this.rolesSelected = [...this.rolesSelected];
		this.roles = this.roles.filter((roleItem) => roleItem.sk !== role.sk);
		if (this.roles.length < 5 && this.pagination.next) {
			this.store.dispatch(
				getFilterRole({
					url: `?_size=10&_name=${this.search}&_page=${this.pagination.next}&_pkClient=${this.data.group.clientPk}`,
				})
			);
		}
	}

	deleteRole(role: IRole) {
		this.roles.push(role);
		this.roles = [...this.roles];
		this.rolesSelected = this.rolesSelected.filter((roleItem) => roleItem.sk !== role.sk);
	}

	save() {
		if (!this.formStatus.invalid) {
			let group: Groups = {
				...this.data.group,
			};
			const status: StatusUSerGroups = {
				...this.formStatus.value,
				roles: this.rolesSelected,
				image: this.icon.url,
			};
			if (this.data.type === 'updateStatus') {
				const statusData: StatusUSerGroups[] = [...this.data.group.statusUser];
				const indexStatus = statusData.findIndex(({ name }) => name === this.data.status.name);
				status.name = this.data.status.name;
				statusData.splice(indexStatus, 1, status);
				group.statusUser = statusData;
				this.store.dispatch(
					updateStatusGroup({ group, ids: { pk: this.data.group.pk, sk: this.data.group.sk } })
				);
			} else {
				group.statusUser = [...this.data.group.statusUser, status];
				this.store.dispatch(
					createStatusGroup({ group, ids: { pk: this.data.group.pk, sk: this.data.group.sk } })
				);
			}
			this.dialogRef.close();
		}
	}

	editIcon() {
		this.isSelectIcon = !this.isSelectIcon;
	}

	dataTranslate() {
		this.subscriptionTranslate = this.translate.init('AccessControl').subscribe((data) => {
			this.translateModal = data.pages.groups.modalStatus;
		});
	}
	ngOnDestroy() {
		this.subscriptionRole?.unsubscribe();
		this.subscriptionTranslate?.unsubscribe();
	}
}
